import { Fragment } from 'react';
import { BrowserRouter as Router, Routes, Route, } from 'react-router-dom';

import Container from './Components/Container';
import Sintesis from './Components/Sintesis';
import Caracterizacion from './Components/Caracterizacion';
import Actividad from './Components/Actividad';
import IdentificacionProcesosPanel from './Components/IdentificacionProcesosPanel';
import PreparacionTerreno from './Components/PreparacionTerreno';
import ManejoPlantas from './Components/ManejoPlantas';
import Cosecha from './Components/Cosecha';
import Ventas from './Components/Ventas'
import Descargas from './Components/Descargas'

function App() {
  return (
    <Fragment className="App">
      <Router>
        <Routes>
          <Route path='/' element={<Container />} >
            {/* Panel de sintesis */}
            <Route index element={<Sintesis />} />

            {/* Seccion 1 */}
            <Route path='caracterizacion' element={<Caracterizacion />} />
            <Route path='actividad' element={<Actividad/>} />

            {/* Seccion 2 */}
            <Route path='identificacion-procesos' element={<IdentificacionProcesosPanel />} />

            {/* Seccion 3 */}
            <Route path='preparacion-terreno' element={<PreparacionTerreno />} />
            <Route path='manejo-plantas' element={<ManejoPlantas />} />
            <Route path='cosecha' element={<Cosecha />} />
            <Route path='venta' element={<Ventas />} />

            {/* Descargas */}
            <Route path='descargas' element={<Descargas />} />

          </Route>
        </Routes>
      </Router>
    </Fragment>
  );
}

export default App;
